import React from 'react';
import PropTypes from 'prop-types';
import Style from './Header.module.scss';

const Header = ({ headline }) => {
  if (!headline) return null;
  return <h2 className={Style.header}>{headline}</h2>;
};

export default Header;

Header.defaultProps = {
  headline: null,
};

Header.propTypes = {
  headline: PropTypes.string,
};
